import React, { Component } from 'react';
import { Drawer, Divider, Table } from 'antd'
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';

class VoucherCustomerUsageList extends Component {
    handleCancel() {
        this.props.onCancel();
    }

    render() {
        var { visible, currentItem } = this.props;

        const columns = [
            {
                title: 'Khách hàng',
                key: 'customer',
                width: 300,
                render: (_, record) => {

                    const customerRecord = record;

                    const customer = {
                        id: customerRecord?.customer_id,
                        code: customerRecord?.customer_code,
                        full_name: customerRecord?.full_name,
                        branch_name: customerRecord?.branch_name,
                        conditions: customerRecord?.conditions,
                        customer_source: customerRecord?.customer_source,
                        // customer_status: customerRecord?.customer_status,
                        customer_status_color: customerRecord?.customer_status_color,
                        medical_book_number: customerRecord?.medical_book_number
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"          // field tuỳ module
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            sourceField="customer_source"
                            statusField="customer_status"
                            statusColorField="customer_status_color"
                        />
                    )
                }
            },
            {
                title: 'Ngày khách sử dụng',
                dataIndex: 'used_date',
                key: 'used_date',
                width: '25%',
                render: (text, record) => {
                    return (
                        <div>{moment(text).format('DD/MM/YYYY')}</div>
                    )
                }
            }
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title={currentItem && currentItem.name ? currentItem.name : "Khách hàng sử dụng"}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '50%'}
                >
                    {visible ? (
                        <div>
                            <Divider orientation="left" orientationMargin="0" className='mt-3'>
                                Khách hàng sử dụng ({currentItem?.customers?.length || 0})
                            </Divider>
                            <Table
                                rowKey="id"
                                size="small"
                                tableLayout='auto'
                                dataSource={currentItem?.customers || []}
                                columns={columns}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                            />
                        </div>
                    ) : null}

                </Drawer>
            </>
        )
    }
}

export default VoucherCustomerUsageList;
